import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { WishlistStorage } from './wishlist-storage.js';

/**
 * A custom element that displays a wishlist icon with count bubble.
 *
 * @typedef {object} WishlistIconRefs
 * @property {HTMLElement} wishlistBubble - The wishlist bubble element.
 * @property {HTMLElement} wishlistBubbleText - The wishlist bubble text element.
 * @property {HTMLElement} wishlistBubbleCount - The wishlist bubble count element.
 *
 * @extends {Component<WishlistIconRefs>}
 */
class WishlistIcon extends Component {
  requiredRefs = ['wishlistBubble', 'wishlistBubbleText', 'wishlistBubbleCount'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.wishlistUpdate, this.#onWishlistUpdate);
    window.addEventListener('pageshow', this.#onPageShow);
    this.#updateCount();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.wishlistUpdate, this.#onWishlistUpdate);
    window.removeEventListener('pageshow', this.#onPageShow);
  }

  #onWishlistUpdate = () => {
    this.#updateCount();
  };

  #onPageShow = (event) => {
    if (event.persisted) {
      this.#updateCount();
    }
  };

  #updateCount() {
    if (!this.refs.wishlistBubbleCount) return;

    const count = WishlistStorage.get().length;
    this.refs.wishlistBubbleCount.textContent = count < 100 ? String(count) : '';
    this.refs.wishlistBubbleCount.classList.toggle('hidden', count === 0);
    this.refs.wishlistBubble?.classList.toggle('visually-hidden', count === 0);
    this.classList.toggle('header-actions__wishlist-icon--has-items', count > 0);
  }
}

if (!customElements.get('wishlist-icon')) {
  customElements.define('wishlist-icon', WishlistIcon);
}
